import { ServiceFeaturesListType } from 'contexts/serviceContext';
import DefaultSidebarView from 'types/enums/DefaultSidebarView';
import SidebarView from 'types/enums/SidebarView';

// For more information on the default sidebar view, see:
// https://app.notion.com/p/drumkitai/Default-Sidebar-View-3ba2b16b087a81d2b464c2db3c6e63c0

function resolvePreferredSidebarView(
  defaultSidebarView: DefaultSidebarView
): SidebarView {
  // Normalize in case values differ in casing/whitespace;
  // Select Load/Active View if default view is `loads` or `active`, otherwise default to Quote/New
  const normalized = (defaultSidebarView ?? DefaultSidebarView.Unset)
    .toLowerCase()
    .trim();
  if (
    normalized === DefaultSidebarView.Loads ||
    normalized === DefaultSidebarView.Active
  ) {
    return SidebarView.Loads;
  }
  return SidebarView.Quote;
}

// Chooses the Drumkit sidebar view from enabled service features
export function getViewBasedOnEmail(
  features: ServiceFeaturesListType
): SidebarView {
  const { isLoadViewEnabled, isQuoteViewEnabled, defaultSidebarView } =
    features;

  if (isLoadViewEnabled && isQuoteViewEnabled) {
    return resolvePreferredSidebarView(defaultSidebarView);
  }

  if (isLoadViewEnabled) {
    return SidebarView.Loads;
  }

  if (isQuoteViewEnabled) {
    return SidebarView.Quote;
  }

  // If neither view is enabled, default to Quote
  return SidebarView.Quote;
}
